import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetMinimumCommitment_package$key } from "./__generated__/useGetMinimumCommitment_package.graphql";

export const useGetMinimumCommitment = (
  packageRef?: useGetMinimumCommitment_package$key | null
) => {
  const pkg = useFragment(useGetMinimumCommitmentFragmentString, packageRef);

  const billingOptions = pkg?.billingOptions;

  const noMinimumCommitment = 0;

  // We are just looking at the first billing option for now.
  // Once we allow them to select the billing option we will need to make sure to
  // grab the right one.
  if (billingOptions && billingOptions.length > 0) {
    return billingOptions[0]?.minimumCommitmentMonths || noMinimumCommitment;
  }

  return noMinimumCommitment;
};

const useGetMinimumCommitmentFragmentString = graphql`
  fragment useGetMinimumCommitment_package on Package {
    id
    billingOptions {
      minimumCommitmentMonths
    }
  }
`;
